module.exports = __webpack_public_path__ + "static/media/au.29e62756.svg";